(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar-old"]) return;
  try {
    
  const announcementBarSlider = new Swiper('.announcement-bar__slider', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20,
    navigation: {
      nextEl: '.announcement-bar .swiper-button-next',
      prevEl: '.announcement-bar .swiper-button-prev',
    },
    autoplay: {
      delay: 4000,
    },
    speed: 600 
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["body-categories"] && !window.DesignMode) return;
  try {
    
  let linkSlider = null;

  function initLinkSlider() {
    const isMobile = window.innerWidth < 769;
  
    if (isMobile && !linkSlider) {
      // Initialize Swiper if not already initialized
      linkSlider = new Swiper('.body-categories__container-slider', {
        slidesPerView: 1.3,
        loop: false,
        spaceBetween: 10,
        watchOverflow: true,
        allowTouchMove: true,
        speed: 600,
        freeMode: true,
        scrollbar: {
          el: '.body-categories .swiper-scrollbar',
          draggable: true
        },
        breakpoints: {
          769: {
            slidesPerView: 3,
            spaceBetween: 20,
          }
        }
      });
    } else if (!isMobile && linkSlider) {
      // Destroy Swiper if it's initialized and no longer needed
      linkSlider.destroy(true, true);
      linkSlider = null;
    }
  }
  
  // Run on page load
  initLinkSlider();
  
  // Run on resize
  window.addEventListener('resize', function () {
    initLinkSlider();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["body-content-slider"] && !window.DesignMode) return;
  try {
    
  const bodyImageSlider = new Swiper('.body-content-slider__images', {
    loop: true,
    spaceBetween: 20,
    effect: 'fade',
    allowTouchMove: true,
    speed: 600,
    breakpoints: {
      769: {
        allowTouchMove: false,
      }
    }
  });

  const bodyContentSlider = new Swiper('.body-content-slider__content-slider', {
    loop: true,
    spaceBetween: 20,
    allowTouchMove: true,
    navigation: {
      nextEl: '.body-content-slider__arrows .swiper-button-next',
      prevEl: '.body-content-slider__arrows .swiper-button-prev',
    },
    breakpoints: {
      769: {
        allowTouchMove: false,
      }
    }
  });

  // Sync sliders
  bodyImageSlider.on('slideChange', slider => {
    let idx = slider.realIndex;

    bodyContentSlider.slideToLoop(idx);
  });

  bodyContentSlider.on('slideChange', slider => {
    let idx = slider.realIndex;

    bodyImageSlider.slideToLoop(idx);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["body-header"]) return;
  try {
    
  // Transparent header on scroll
  const header =  document.querySelector('.shopify-section-header');
  const scrollPoint = document.getElementById('MainContent');

  document.addEventListener('scroll', function(e) {
    const scrollPosition = window.scrollY;

    if (scrollPosition > scrollPoint.offsetTop) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  });

  (() => {
    const scrollPosition = window.scrollY;

    if (scrollPosition > scrollPoint.offsetTop) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  })();

  // Search dropdown
  const openSearch = document.querySelector('.js-open-search');
  const closeSearch = document.querySelector('.js-close-search');
  const search = document.querySelector('.header__search');
  const searchInput = document.querySelector('.header__search .header__search-input');


  openSearch.addEventListener('click', () => {
    console.log('asdlfkjhas');
    if (search.classList.contains('is-visible')) {
      search.classList.remove('is-visible');
    } else {
      search.classList.add('is-visible');
      searchInput.setAttribute('tabindex', '0');
      setTimeout(function() {
        searchInput.focus();
      }, 500)
    }
  });

  closeSearch.addEventListener('click', () => {
    search.classList.remove('is-visible');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["body-product-grid"] && !window.DesignMode) return;
  try {
    
  const productGridSlider = new Swiper('.body-product-grid__slider', {
    slidesPerView: 1,
    loop: false,
    spaceBetween: 20,
    watchOverflow: true,
    allowTouchMove: true,
    speed: 400, 
    freeMode: true,
    breakpoints: {
      1: {
          spaceBetween: 10,
          slidesPerView: 1.5
        },
        601: {
          spaceBetween: 10,
          slidesPerView: 2
        },
        769: {
          slidesPerView: 2.5,
          allowTouchMove: false,
          freeMode: false
        },
        1051: {
          slidesPerView: 3,
          allowTouchMove: false,
          freeMode: false
        },
        1200: {
          slidesPerView: 4,
          allowTouchMove: false,
          freeMode: false
        }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["body-product-slider"] && !window.DesignMode) return;
  try {
    
  const productSlider = new Swiper('.body-product-slider__slider', {
    slidesPerView: 1,
    loop: false,
    spaceBetween: 20,
    watchOverflow: true,
    allowTouchMove: true,
    speed: 400, 
    freeMode: true,
    navigation: {
      prevEl: '.body-product-slider .swiper-button-prev',
      nextEl: '.body-product-slider .swiper-button-next'
    },
    scrollbar: {
      el: '.body-product-slider__scrollbar', 
      draggable: true
    },
    breakpoints: {
      1: {
        spaceBetween: 10,
        slidesPerView: 1.5
      },
      601: {
        spaceBetween: 10,
        slidesPerView: 2
      },
      769: {
        slidesPerView: 2.5,
        allowTouchMove: false,
        freeMode: false
      },
      1051: {
        slidesPerView: 3,
        allowTouchMove: false,
        freeMode: false
      },
      1200: {
        slidesPerView: 4,
        allowTouchMove: false,
        freeMode: false
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["body-video"] && !window.DesignMode) return;
  try {
    
  const cover = document.querySelector('.body-video__cover');
  cover.addEventListener('click', event => {
    const video = event.currentTarget.parentElement.querySelector('video');
    cover.classList.add('faded');
    video.play();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["care-tips-products"]) return;
  try {
    
  const careTipsProducts = new Swiper('.care-tips-product__container', {
    slidesPerView: 1,
    loop: false,
    spaceBetween: 10,
    watchOverflow: true,
    allowTouchMove: true,
    speed: 400,
    freeMode: true,
    scrollbar: {
      el: '.product-slider__collection .swiper-scrollbar',
      draggable: true
    },
    breakpoints: {
      1: {
        spaceBetween: 10,
        slidesPerView: 1.5
      },
      601: {
        spaceBetween: 10,
        slidesPerView: 2
      },
      769: {
        spaceBetween: 20,
        slidesPerView: 2.5,
        allowTouchMove: false,
        freeMode: false
      },
      1051: {
        spaceBetween: 20,
        slidesPerView: 3,
        allowTouchMove: false,
        freeMode: false
      },
      1200: {
        spaceBetween: 20,
        slidesPerView: 4,
        allowTouchMove: false,
        freeMode: false
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-blocks"] && !window.DesignMode) return;
  try {
    
  const playButtons = document.querySelectorAll('.content-play');
  playButtons.forEach(button => {
    button.addEventListener('click', event => {
      const videoId = button.dataset.video;
      const video = button.parentElement.querySelector(`.content-video[data-video="${videoId}"]`);
      video.currentTime = 0;
      video.play();
      button.remove();
    })
  });

  const socialSlider = new Swiper('.content-blocks__social-grid', {
    slidesPerView: 1.75,
    loop: false,
    spaceBetween: 20,
    watchOverflow: true,
    allowTouchMove: true,
    centeredSlides: true,
    loop: true,
    speed: 400,
    breakpoints: {
      600: {
        slidesPerView: 3,
        spaceBetween: 30,
        allowTouchMove: false,
        centeredSlides: false
      }
    }
  });

  const slideshowSlider = new Swiper('.content-blocks__slideshow', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20,
    watchOverflow: true,
    loop: true,
    speed: 400,
    navigation: {
      nextEl: '.content-blocks__slideshow-block .swiper-button-next',
      prevEl: '.content-blocks__slideshow-block .swiper-button-prev',
    },
    breakpoints: {
      769: {
        spaceBetween: 30
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-banner"] && !window.DesignMode) return;
  try {
    
  let bannerTL = gsap.timeline({
    scrollTrigger: {
      trigger: '.editorial-banner',
      start: "top 90%",
      end: "top 75%"
    }
  });

  bannerTL.from('.editorial-banner', {
    opacity: 0,
    y: 20,
    duration: .8
  })
  .from('.editorial-banner .h1', {
    height: 0,
    duration: 1
  }, '>')
  .to('.editorial-banner .h1', {
    blur: 0,
    duration: 1.2
  }, '-=30%');


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-header"] && !window.DesignMode) return;
  try {
    
  let editorialHeaderTL = gsap.timeline({ delay: .8 });

  editorialHeaderTL
  .from('.editorial-header .h1', {
    height: 0,
    duration: 1
  }, '>')
  .to('.editorial-header .h1', {
    blur: 0,
    duration: 1.2
  }, '-=30%');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !window.DesignMode) return;
  try {
    
  const featuredCollection = new Swiper('.product-slider__collection', {
    slidesPerView: 1,
    loop: false,
    spaceBetween: 10,
    watchOverflow: true,
    allowTouchMove: true,
    speed: 400,
    freeMode: true,
    scrollbar: {
      el: '.product-slider__collection .swiper-scrollbar',
      draggable: true
    },
    breakpoints: {
      1: {
        spaceBetween: 10,
        slidesPerView: 1.5
      },
      601: {
        spaceBetween: 10,
        slidesPerView: 2
      },
      769: {
        spaceBetween: 20,
        slidesPerView: 2.5,
        allowTouchMove: false,
        freeMode: false
      },
      1051: {
        spaceBetween: 20,
        slidesPerView: 3,
        allowTouchMove: false,
        freeMode: false
      },
      1200: {
        spaceBetween: 20,
        slidesPerView: 4,
        allowTouchMove: false,
        freeMode: false
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fit-dictionary-list"]) return;
  try {
    
  const categoryButtons = document.querySelectorAll('.fit-dictionary__category');

  categoryButtons.forEach(categoryButton => {
    categoryButton.addEventListener('click', event => {
      const category = event.currentTarget.dataset.category;
      const activeCategoryButton = document.querySelector(`.fit-dictionary__category.active`);
      const allItems = document.querySelectorAll('.fit-dictionary__item');
      
      activeCategoryButton.classList.remove('active');
      event.currentTarget.classList.add('active');

      allItems.forEach(item => {
        const currentCategory = item.dataset.category;

        item.classList.remove('hidden');
        if (category != currentCategory && category != 'all') {
          item.classList.add('hidden');
        }
      });
      
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fit-dictionary-navigation"]) return;
  try {
    
  const links = document.querySelectorAll('.fit-dictionary-nav__button');
  const navHeight = document.querySelector('.fit-dictionary-nav__button').clientHeight + document.querySelector('.fit-dictionary-nav').clientHeight + 70;

  window.addEventListener('scroll', (event) => {
    const fromTop = window.scrollY;

    links.forEach(link => {
      const section = document.querySelector(`.fit-dictionary__item-group[data-letter="${link.dataset.letter}"]`);

      if (section) {
        if ((section.offsetTop - navHeight) <= fromTop && (section.offsetTop - navHeight) + section.clientHeight > fromTop) {
          link.classList.add('active');
        } else {
          link.classList.remove('active');
        }
      }
    });
  });

  // Scroll to link
  links.forEach(link => {
    link.addEventListener('click', event => {
      event.preventDefault();
      const letter = event.currentTarget.dataset.letter;
      const section = document.querySelector(`.fit-dictionary__item-group[data-letter="${letter}"]`)

      window.scrollTo({
        top: section.offsetTop - navHeight,
        behavior: "smooth"
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fit-guide-beachwear"]) return;
  try {
    
  const beachwearNavigationSlider = new Swiper('.fit-guide--beachwear .fit-guide__navigation-slider', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20,
    centeredSlides: true,
    slideToClickedSlide: true,
    navigation: {
      nextEl: '.fit-guide--beachwear .swiper-button-next',
      prevEl: '.fit-guide--beachwear .swiper-button-prev',
    },
    speed: 900,
    breakpoints: {
      768: {
        slidesPerView: 3
      },
      1050: {
        slidesPerView: 5
      }
    }
  }); 

  const beachwearContentSlider = new Swiper('.fit-guide--beachwear .fit-guide__slider', {
    loop: true,
    spaceBetween: 20,
    effect: 'fade',
    allowTouchMove: false,
    speed: 800
  });

  // Sync sliders with navigation
  beachwearNavigationSlider.on('slideChange', slider => {
    let idx = slider.realIndex;

    beachwearContentSlider.slideToLoop(idx);
  });

  // Sync sliders with mobile
  var beachwearSelect = document.querySelector('.fit-guide--beachwear .fit-guide__select');
  beachwearSelect.addEventListener('change', event => {
    let idx = Number(event.target.value);
 
    beachwearContentSlider.slideToLoop(idx);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fit-guide-bottoms-body"]) return;
  try {
    
  const bottomNavigationSlider = new Swiper('.fit-guide--bottoms .fit-guide__navigation-slider', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20,
    centeredSlides: true,
    slideToClickedSlide: true,
    navigation: {
      nextEl: '.fit-guide--bottoms .swiper-button-next',
      prevEl: '.fit-guide--bottoms .swiper-button-prev',
    },
    speed: 900,
    breakpoints: {
      768: {
        slidesPerView: 3
      },
      1050: {
        slidesPerView: 5
      }
    }
  }); 

  const bottomContentSlider = new Swiper('.fit-guide--bottoms .fit-guide__slider', {
    loop: true,
    spaceBetween: 20,
    effect: 'fade',
    allowTouchMove: false,
    speed: 800
  });

  // Sync sliders with navigation
  bottomNavigationSlider.on('slideChange', slider => {
    let idx = slider.realIndex;

    bottomContentSlider.slideToLoop(idx);
  });

  // Sync sliders with mobile
  var bottomsSelect = document.querySelector('.fit-guide--bottoms .fit-guide__select');
  bottomsSelect.addEventListener('change', event => {
    let idx = Number(event.target.value);

    bottomContentSlider.slideToLoop(idx);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fit-guide-bottoms"]) return;
  try {
    
  const bottomNavigationSlider = new Swiper('.fit-guide--bottoms .fit-guide__navigation-slider', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20,
    centeredSlides: true,
    slideToClickedSlide: true,
    navigation: {
      nextEl: '.fit-guide--bottoms .swiper-button-next',
      prevEl: '.fit-guide--bottoms .swiper-button-prev',
    },
    speed: 900,
    breakpoints: {
      768: {
        slidesPerView: 3
      },
      1050: {
        slidesPerView: 5
      }
    }
  }); 

  const bottomContentSlider = new Swiper('.fit-guide--bottoms .fit-guide__slider', {
    loop: true,
    spaceBetween: 20,
    effect: 'fade',
    allowTouchMove: false,
    speed: 800
  });

  // Sync sliders with navigation
  bottomNavigationSlider.on('slideChange', slider => {
    let idx = slider.realIndex;

    bottomContentSlider.slideToLoop(idx);
  });

  // Sync sliders with mobile
  var bottomsSelect = document.querySelector('.fit-guide--bottoms .fit-guide__select');
  bottomsSelect.addEventListener('change', event => {
    let idx = Number(event.target.value);

    bottomContentSlider.slideToLoop(idx);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fit-guide-editorial-cta-body"]) return;
  try {
    
  let bannerTL = gsap.timeline({
    scrollTrigger: {
      trigger: '.fit-guide-cta',
      start: "top 90%",
      end: "top 75%"
    }
  });

  bannerTL.from('.fit-guide-cta', {
    opacity: 0,
    duration: .8
  })
  .from('.fit-guide-cta .h1', {
    height: 0,
    duration: 1
  }, '>')
  .to('.fit-guide-cta .h1', {
    blur: 0,
    duration: 1.2
  }, '-=30%');


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fit-guide-editorial-cta"]) return;
  try {
    
  let bannerTL = gsap.timeline({
    scrollTrigger: {
      trigger: '.fit-guide-cta',
      start: "top 90%",
      end: "top 75%"
    }
  });

  bannerTL.from('.fit-guide-cta', {
    opacity: 0,
    duration: .8
  })
  .from('.fit-guide-cta .h1', {
    height: 0,
    duration: 1
  }, '>')
  .to('.fit-guide-cta .h1', {
    blur: 0,
    duration: 1.2
  }, '-=30%');


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fit-guide-one-pieces"]) return;
  try {
    
  const onePieceNavigationSlider = new Swiper('.fit-guide--one-piece .fit-guide__navigation-slider', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20,
    centeredSlides: true,
    slideToClickedSlide: true,
    navigation: {
      nextEl: '.fit-guide--one-piece .swiper-button-next',
      prevEl: '.fit-guide--one-piece .swiper-button-prev',
    },
    speed: 900,
    breakpoints: {
      768: {
        slidesPerView: 3
      },
      1050: {
        slidesPerView: 5
      }
    }
  }); 

  const onePieceContentSlider = new Swiper('.fit-guide--one-piece .fit-guide__slider', {
    loop: true,
    spaceBetween: 20,
    effect: 'fade',
    allowTouchMove: false,
    speed: 800
  });

  // Sync sliders with navigation
  onePieceNavigationSlider.on('slideChange', slider => {
    let idx = slider.realIndex;

    onePieceContentSlider.slideToLoop(idx);
  });

  // Sync sliders with mobile 
  var onePieceSelect = document.querySelector('.fit-guide--one-piece .fit-guide__select');
  onePieceSelect.addEventListener('change', event => {
    let idx = Number(event.target.value);

    onePieceContentSliderLoop(idx);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fit-guide-size-chart-body"]) return;
  try {
    
  // Fit tabs
  const fitTabs = document.querySelectorAll('.fit-size-chart__tab');

  fitTabs.forEach(fitTab => {
    fitTab.addEventListener('click', event => {
      const tab = event.currentTarget.dataset.tab;

      document.querySelector('.fit-size-chart__tab.active').classList.remove('active');
      event.currentTarget.classList.add('active');

      document.querySelector('.fit-size-chart__chart.active').classList.remove('active');
      document.querySelector(`.fit-size-chart__chart[data-tab="${tab}"]`).classList.add('active');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fit-guide-size-chart"]) return;
  try {
    
  // Fit tabs
  const fitTabs = document.querySelectorAll('.fit-size-chart__tab');

  fitTabs.forEach(fitTab => {
    fitTab.addEventListener('click', event => {
      const tab = event.currentTarget.dataset.tab;

      document.querySelector('.fit-size-chart__tab.active').classList.remove('active');
      event.currentTarget.classList.add('active');

      document.querySelector('.fit-size-chart__chart.active').classList.remove('active');
      document.querySelector(`.fit-size-chart__chart[data-tab="${tab}"]`).classList.add('active');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fit-guide-tabs-body"]) return;
  try {
    
  const tabs = document.querySelectorAll('.fit-guide-header__tab');
  tabs.forEach(tab => {
    tab.addEventListener('click', event => {
      const tab = event.currentTarget.dataset.tab;

      document.querySelector('.fit-guide-header__tab.active').classList.remove('active');
      event.currentTarget.classList.add('active');

      document.querySelector('.fit-guide.active').classList.remove('active');
      document.querySelector(`.fit-guide[data-tab="${tab}"]`).classList.add('active');
    })
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fit-guide-tabs"]) return;
  try {
    
  const tabs = document.querySelectorAll('.fit-guide-header__tab');
  tabs.forEach(tab => {
    tab.addEventListener('click', event => {
      const tab = event.currentTarget.dataset.tab;

      document.querySelector('.fit-guide-header__tab.active').classList.remove('active');
      event.currentTarget.classList.add('active');

      document.querySelector('.fit-guide.active').classList.remove('active');
      document.querySelector(`.fit-guide[data-tab="${tab}"]`).classList.add('active');
    })
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fit-guide-tops-body"]) return;
  try {
    
  const topsNavigationSlider = new Swiper('.fit-guide--tops .fit-guide__navigation-slider', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20,
    centeredSlides: true,
    slideToClickedSlide: true,
    navigation: {
      nextEl: '.fit-guide--tops .swiper-button-next',
      prevEl: '.fit-guide--tops .swiper-button-prev',
    },
    speed: 900,
    breakpoints: {
      768: {
        slidesPerView: 3
      },
      1050: {
        slidesPerView: 5
      }
    }
  }); 

  const topsContentSlider = new Swiper('.fit-guide--tops .fit-guide__slider', {
    loop: true,
    spaceBetween: 20,
    effect: 'fade',
    allowTouchMove: false,
    speed: 800
  });

  // Sync sliders with navigation
  topsNavigationSlider.on('slideChange', slider => {
    let idx = slider.realIndex;

    topsContentSlider.slideToLoop(idx);
  });

  // Sync sliders with mobile
  var topsSelect = document.querySelector('.fit-guide--tops .fit-guide__select');
  topsSelect.addEventListener('change', event => {
    let idx = Number(event.target.value);

    topsContentSlider.slideToLoop(idx);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fit-guide-tops"]) return;
  try {
    
  const topsNavigationSlider = new Swiper('.fit-guide--tops .fit-guide__navigation-slider', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20,
    centeredSlides: true,
    slideToClickedSlide: true,
    navigation: {
      nextEl: '.fit-guide--tops .swiper-button-next',
      prevEl: '.fit-guide--tops .swiper-button-prev',
    },
    speed: 900,
    breakpoints: {
      768: {
        slidesPerView: 3
      },
      1050: {
        slidesPerView: 5
      }
    }
  }); 

  const topsContentSlider = new Swiper('.fit-guide--tops .fit-guide__slider', {
    loop: true,
    spaceBetween: 20,
    effect: 'fade',
    allowTouchMove: false,
    speed: 800
  });

  // Sync sliders with navigation
  topsNavigationSlider.on('slideChange', slider => {
    let idx = slider.realIndex;

    topsContentSlider.slideToLoop(idx);
  });

  // Sync sliders with mobile
  var topsSelect = document.querySelector('.fit-guide--tops .fit-guide__select');
  topsSelect.addEventListener('change', event => {
    let idx = Number(event.target.value);

    topsContentSlider.slideToLoop(idx);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fit-guide"] && !window.DesignMode) return;
  try {
    
  const fitGuideNavigationSlider = new Swiper('.fit-guide-section__navigation-slider', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20,
    centeredSlides: true,
    slideToClickedSlide: true,
    navigation: {
      nextEl: '.fit-guide-section__navigation .swiper-button-next',
      prevEl: '.fit-guide-section__navigation .swiper-button-prev',
    },
    speed: 900,
    breakpoints: {
      1150: {
        slidesPerView: 3,
      }
    }
  }); 

  const fitGuideContentSlider = new Swiper('.fit-guide-section__content-slider', {
    loop: true,
    spaceBetween: 20,
    effect: 'fade',
    allowTouchMove: false,
    speed: 800
  });

  const fitGuideImageSlider = new Swiper('.fit-guide-section__images', {
    loop: true,
    spaceBetween: 20,
    effect: 'fade',
    allowTouchMove: false,
    speed: 800
  });

  // Sync sliders with navigation
  fitGuideNavigationSlider.on('slideChange', slider => {
    let idx = slider.realIndex;

    fitGuideContentSlider.slideToLoop(idx);
    fitGuideImageSlider.slideToLoop(idx);
  });

  // Sync sliders with mobile
  var mobileSelect = document.querySelector('.fit-guide-section__select');
  mobileSelect.addEventListener('change', event => {
    let idx = Number(event.target.value);

    fitGuideContentSlider.slideToLoop(idx);
    fitGuideImageSlider.slideToLoop(idx);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Transparent header on scroll
  const header =  document.querySelector('.shopify-section-header');
  const scrollPoint = document.getElementById('MainContent');

  document.addEventListener('scroll', function(e) {
    const scrollPosition = window.scrollY;

    if (scrollPosition > scrollPoint.offsetTop) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  });

  (() => {
    const scrollPosition = window.scrollY;

    if (scrollPosition > scrollPoint.offsetTop) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  })();

  // Search dropdown
  const openSearch = document.querySelector('.js-open-search');
  const closeSearch = document.querySelector('.js-close-search');
  const search = document.querySelector('.header__search');
  const searchInput = document.querySelector('.header__search .header__search-input');
  

  openSearch.addEventListener('click', () => {
    console.log('asdlfkjhas')
    if (search.classList.contains('is-visible')) {
      search.classList.remove('is-visible');
    } else {
      search.classList.add('is-visible');
      searchInput.setAttribute('tabindex', '0');
      setTimeout(function() {
        searchInput.focus();
      }, 500)
    }
  });

  closeSearch.addEventListener('click', () => {
    search.classList.remove('is-visible');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["legal-popup"]) return;
  try {
    
  const legalPopup = document.querySelector('.legal-popup');
  const legalPopupClose = document.querySelector('.legal-popup__close');

  if (getCookie('legalCookie')) {
    legalPopup.classList.remove('is-visible');
  } else {
    legalPopup.classList.add('is-visible');
  }

  legalPopupClose.addEventListener('click', event => {
    const day = legalPopup.dataset.day;

    legalPopup.classList.remove('is-visible');
    setCookie('legalCookie', true, day);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["link-blocks"] && !window.DesignMode) return;
  try {
    
  const linkSlider = new Swiper('.link-blocks__container-slider', {
    slidesPerView: 1.3,
    loop: false,
    spaceBetween: 10,
    watchOverflow: true,
    allowTouchMove: true,
    speed: 600,
    freeMode: true,
    scrollbar: {
      el: '.link-blocks .swiper-scrollbar',
      draggable: true
    },
    breakpoints: {
      769: {
        slidesPerView: 3,
        spaceBetween: 20,
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-contest"] && !window.DesignMode) return;
  try {
    
  const slideshowSlider = new Swiper('.contest__image-slider', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20,
    watchOverflow: true,
    speed: 400,
    pagination: {
      el: '.contest__pagination',
      clickable: true
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-bundle"]) return;
  try {
    
  // Product sliders
  const productThumbsSlider = new Swiper('.product__thumbnail-list', {
    slidesPerView: 4,
    loop: false,
    spaceBetween: 20,
    direction: 'vertical',
    mousewheelControl: true,
    freeMode: true,
    navigation: {
      nextEl: '.product__thumbnail-wrapper .swiper-button-next'
    },
    breakpoints: {
      851: {
        loop: true,
        spaceBetween: 20
      },
      1151: {
        loop: true,
        spaceBetween: 40
      }
    }
  });

  const productSlider = new Swiper('.product__media-list', {
    slidesPerView: 1.2,
    loop: false,
    spaceBetween: 10,
    freeMode: true,
    thumbs: {
      swiper: productThumbsSlider
    },
    scrollbar: {
      el: '.product__media-scrollbar',
      draggable: true
    },
    breakpoints: {
      851: {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        freeMode: false
      }
    }
  });

  // Product dropdowns
  const dropdownButtons = document.querySelectorAll('.product__dropdown-header');

  dropdownButtons.forEach(dropdownButton => {
    dropdownButton.addEventListener('click', event => {
      const parent = event.currentTarget.parentElement;
      const content = parent.querySelector('.product__dropdown-content');

      parent.classList.toggle('active');
      slideToggle(content, 300);
    });
  });

  // Size chart dropdown
  const sizeChartButton = document.querySelector('.size-chart-dropdown__header');

  sizeChartButton.addEventListener('click', event => {
    event.preventDefault();
    const parent = event.currentTarget.parentElement;
    const content = parent.querySelector('.size-chart-dropdown__content');

    parent.classList.toggle('active');
    slideToggle(content, 300);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
    // Product sliders 
    window.productThumbsSlider = new Swiper('.product__thumbnail-list', {
    slidesPerView: 4,
    loop: false,
    spaceBetween: 20,
    direction: 'vertical', 
    mousewheelControl: true,
    freeMode: true,
    threshold: 15,
    navigation: {
      nextEl: '.product__thumbnail-wrapper .swiper-button-next'
    },
    breakpoints: {
      851: {
        loop: true,
        spaceBetween: 20
      },
      1151: {
        loop: true,
        spaceBetween: 40
      }
    }
  });

  window.productSlider = new Swiper('.product__media-list', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 0,
    initialSlide: Number(document.querySelector('.product__media-list').dataset.position) - 1,
    thumbs: {
      swiper: window.productThumbsSlider
    },
    scrollbar: {
      el: '.product__media-scrollbar',
      draggable: true
    },
    navigation: {
      prevEl: '.product__media-list .swiper-button-prev',
      nextEl: '.product__media-list .swiper-button-next'
    },
    breakpoints: {
      851: {
        slidesPerView: 1,
        spaceBetween: 20,
      }
    }
  });
 
  // Product dropdowns
  const dropdownButtons = document.querySelectorAll('.product__dropdown-header');

  dropdownButtons.forEach(dropdownButton => {
    dropdownButton.addEventListener('click', event => {
      const parent = event.currentTarget.parentElement;
      const content = parent.querySelector('.product__dropdown-content');

      parent.classList.toggle('active');
      slideToggle(content, 300);
    }); 
  });

  // Size chart dropdown
  const sizeChart = document.querySelector('.size-chart');
  const sizeChartButton = document.querySelector('.product__size-chart');

  sizeChartButton.addEventListener('click', event => {
    sizeChart.classList.add('is-visible');
    document.body.classList.add('scroll-lock');
  });

  const closeSizeChartButtons = document.querySelectorAll('.js-close-size-chart');
  closeSizeChartButtons.forEach(button => {
    button.addEventListener('click', event => {
      sizeChart.classList.remove('is-visible');
      document.body.classList.remove('scroll-lock');
    });
  });

  // Size chart tabs
  const tabs = document.querySelectorAll('.size-chart__tab');
  tabs.forEach(tab => {
    tab.addEventListener('click', event => {
      const tabName = tab.dataset.tab;

      document.querySelector('.size-chart__tab.active').classList.remove('active');
      tab.classList.add('active');

      document.querySelector('.size-chart__content.active').classList.remove('active');
      document.querySelector(`.size-chart__content[data-tab="${tabName}"]`).classList.add('active');
    });
  });

  // Zoom
  initZoom();
  window.addEventListener('resize', event => {
    initZoom();
  });

  function initZoom() {
    if (window.innerWidth < 769) {
      $('.product__media').trigger('zoom.destroy');
    } else {
      $('.product__media').zoom({magnify: 1.5, url: $(this).data('fullsize')});
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-cards"] && !window.DesignMode) return;
  try {
    
  const pressSlider = new Swiper('.page-cards__slider', {
    slidesPerView: 1.2,
    loop: false,
    spaceBetween: 10,
    freeMode: true,
    breakpoints: {
      768: {
        slidesPerView: 4,
        spaceBetween: 20,
        loop: true,
        freeMode: false
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-bar"] && !window.DesignMode) return;
  try {
    
  // Handle opening / closing dropdowns
  const colorButton = document.querySelector('.product__swatches-button');
  if (colorButton) {
    colorButton.addEventListener('click', event => {
      colorButton.classList.toggle('active');
    });
  }

  const dropdownButtons = document.querySelectorAll('.product-form__input-button');
  dropdownButtons.forEach(dropdownButton => {
    dropdownButton.addEventListener('click', event => {
      dropdownButton.classList.toggle('active');
    });
  });

  const variantButtons = document.querySelectorAll('.product-form__input input[type="radio"]');
  variantButtons.forEach(variantButton => {
    variantButton.addEventListener('click', event => {

      const selectedValues = document.querySelectorAll(`.product-form__input input[value="${variantButton.value}"]`);
      selectedValues.forEach(selectedVal => {
        selectedVal.checked = true;
      });

      dropdownButtons.forEach(dropdownButton => {
        dropdownButton.classList.remove('active');
      });
      
    });
  });

  // Show bar after scroll
  const headroom = new Headroom(document.querySelector('.product-bar'), { offset: 350 });
  headroom.init();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            const recommendationsSlider = new Swiper('.product-recommendations__grid', {
              slidesPerView: 1,
              loop: false,
              spaceBetween: 10,
              watchOverflow: true,
              allowTouchMove: true,
              speed: 400,
              freeMode: true,
              mousewheel: {
                forceToAxis: true
              },
              scrollbar: {
                el: '.product-recommendations__scrollbar',
                draggable: true
              },
              breakpoints: {
                1: {
                  spaceBetween: 10,
                  slidesPerView: 1.5
                },
                601: {
                  spaceBetween: 10,
                  slidesPerView: 2
                },
                769: {
                  spaceBetween: 20,
                  slidesPerView: 2.5
                },
                1051: {
                  spaceBetween: 20,
                  slidesPerView: 3
                },
                1200: {
                  spaceBetween: 20,
                  slidesPerView: 4,
                  allowTouchMove: false,
                  freeMode: false
                }
              }
            });
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-slider"] && !window.DesignMode) return;
  try {
    
  var productSliders = [];
  [...document.querySelectorAll('.product-slider__collection')].forEach((el, i) => {
    var handle = '#collection--' + el.dataset.collection;

    productSliders[i] = new Swiper(handle, {
      slidesPerView: 1,
      loop: false,
      spaceBetween: 20,
      watchOverflow: true,
      allowTouchMove: true,
      speed: 400,
      freeMode: true,
      navigation: {
        prevEl: handle + '-arrow-left',
        nextEl: handle + '-arrow-right'
      },
      scrollbar: {
        el: handle + '-scrollbar',
        draggable: true
      },
      breakpoints: {
        1: {
          spaceBetween: 10,
          slidesPerView: 1.5
        },
        601: {
          spaceBetween: 10,
          slidesPerView: 2
        },
        769: {
          slidesPerView: 2.5,
          allowTouchMove: false,
          freeMode: false
        },
        1051: {
          slidesPerView: 3,
          allowTouchMove: false,
          freeMode: false
        },
        1200: {
          slidesPerView: 4,
          allowTouchMove: false,
          freeMode: false
        }
      }
    });
  });

  // Tab change
  [...document.querySelectorAll('.product-slider__navigation-item')].forEach((el, i) => {
    el.addEventListener('click', event => {
      const el = event.target;
      const collection = el.dataset.collection;

      if (!el.classList.contains('active')) {
        document.querySelector('.product-slider__navigation-item.active').classList.remove('active');
        el.classList.add('active');

        document.querySelector('.product-slider__arrows-wrapper.active').classList.remove('active');
        document.querySelector(`.product-slider__arrows-wrapper[data-collection="${collection}"]`).classList.add('active'); 

        document.querySelector('.product-slider__collection.active').classList.remove('active');
        document.querySelector(`.product-slider__collection[data-collection="${collection}"]`).classList.add('active'); 

        document.querySelector('.product-slider__col-link.active').classList.remove('active');
        document.querySelector(`.product-slider__col-link[data-collection="${collection}"]`).classList.add('active'); 

        document.querySelector('.product-slider__col-link--mobile.active').classList.remove('active');
        document.querySelector(`.product-slider__col-link--mobile[data-collection="${collection}"]`).classList.add('active'); 
      }
    }); 
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-articles"] && !window.DesignMode) return;
  try {
    
  const filterButton = document.querySelectorAll('.related-articles__filters button');

  filterButton.forEach(button => {
    button.addEventListener('click', event => {
      const tag = event.currentTarget.dataset.tag;
      const nextGroup = document.querySelector(`.related-articles__articles-group[data-tag="${tag}"]`);
      console.log('GROUP', nextGroup)

      const activeButton = document.querySelector('.related-articles__filters button.active');
      const activeGroup = document.querySelector('.related-articles__articles-group.active');


      activeButton.classList.remove('active');
      event.currentTarget.classList.add('active');

      activeGroup.classList.remove('active');
      nextGroup.classList.add('active');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rewards-levels"]) return;
  try {
    
  const rewardsLevelsSlider = new Swiper('.rewards-levels__container', {
    slidesPerView: 1.9,
    loop: false,
    spaceBetween: 20,
    watchOverflow: true,
    allowTouchMove: true,
    centeredSlides: true,
    loop: true,
    speed: 400,
    pagination: {
      el: '.rewards-levels__pagination'
    },
    breakpoints: {
      769: {
        slidesPerView: 3,
        spaceBetween: 60,
        allowTouchMove: false,
        freeMode: false,
        centeredSlides: false
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
